import * as React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface RememberMeCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
}

/**
 * Remember Me Checkbox Component
 *
 * Checkbox for "Remember me" option in login form.
 */
export function RememberMeCheckbox({
  checked,
  onCheckedChange,
  id = "remember-me",
}: RememberMeCheckboxProps) {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(checked) => onCheckedChange(checked === true)}
      />
      <Label
        htmlFor={id}
        className="text-sm font-normal text-muted-foreground cursor-pointer"
      >
        Remember me
      </Label>
    </div>
  );
}

export default RememberMeCheckbox;
